import React, { FC } from "react";
import styled from "styled-components";
import { CatalogCategory } from "../queries/auto-generated/schemas";
import Item from "./item/item";
import { prettyUrlFragment } from "../helpers";

const CategoryGroup: FC<{ catalogCategory: CatalogCategory }> = ({
  catalogCategory,
}) => {
  const items = catalogCategory?.items?.filter((i) => i?.id ?? false) ?? [];
  return (
    <Container>
      <h2 id={prettyUrlFragment(catalogCategory?.name ?? "")}>
        {catalogCategory.name}
      </h2>
      <FlexBox>
        {items?.map((item, index) => (
          <Item key={index} id={item?.id ?? ""} />
        ))}
      </FlexBox>
    </Container>
  );
};

const Container = styled.section`
  margin-bottom: 1em;
  h2 {
    text-align: center;
  }
`;

const FlexBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

export default CategoryGroup;
